import type { ReactNode } from 'react';

import Box from '@mui/material/Box';

import { normalizeSx } from '@/utils/normalizeSx';

import type { Sx } from '@/types/helpers';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  sx?: Sx;
  className?: string;
  containerSX?: Sx;
}

const CustomTabPanel = ({
  children,
  value,
  index,
  sx,
  className,
  containerSX,
  ...other
}: TabPanelProps) => {
  return (
    <Box
      aria-labelledby={`tab-${index}`}
      className={className}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      role='tabpanel'
      sx={containerSX}
      {...(other as any)}
    >
      {value === index && <Box sx={normalizeSx(sx)}>{children}</Box>}
    </Box>
  );
};

export default CustomTabPanel;
